export function getPixelValue<T extends number>(pixels: `${T}px`): T {
  return Number(pixels.replace('px', '')) as T;
}
